module.exports = __webpack_public_path__ + "img/loader.f3c5c80c6560a08e6543724a878c7769.svg";